export function hasPermission(user, permission) {
  if (!user || !user.permissions) return false;
  return user.permissions.includes("*") || user.permissions.includes(permission);
}

// True if the user holds ANY of the given permissions.
export function hasAnyPermission(user, permissions = []) {
  if (!user || !user.permissions) return false;
  if (user.permissions.includes("*")) return true;
  return permissions.some((p) => user.permissions.includes(p));
}

// True only for the Owner / super-user tier (sits above admin; NOT granted by "*").
export function isSuperuser(user) {
  return !!(user && user.is_superuser);
}

// Domain (risk-area) scope check. user.domains is a list of theme-ids or ["*"].
export function inScope(user, themeId) {
  if (!user) return false;
  const d = user.domains || [];
  return d.includes("*") || d.includes(themeId);
}
